import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=5a4f9484&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\migame-pe\\migame-pe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4f9484"]])

export default __exports__